import { module } from 'modujs';
import $ from 'jquery';

export default class extends module {
    constructor(m) {
        super(m);

        console.log('init simple mapp')
        let elt = $(this.el).find('.map-container__google').get(0);
        let infos = $(this.el).find('.map-container__infos').get(0);
        let zoom = $(this.el).find('.map-container__infos').data('zoom');

        this.initMap({
            container : elt,
            latitude :	Number(infos.dataset.latitude),
            longitude :	Number(infos.dataset.longitude),
            url : infos.dataset.url,
            zoom : zoom
        });

    }

    initMap(options) {

        var pixLatLng = {lat: options.latitude, lng: options.longitude};
        let myMap = new google.maps.Map(options.container, {
                zoom: options.zoom,
                center: pixLatLng,
            }
        );

        let marker = new google.maps.Marker({
            position: pixLatLng,
            map: myMap,
            title: 'Bulb',
            icon: {
                url: options.url,
                //if we want to force size of the image
                // scaledSize: new google.maps.Size(90, 90)
            }
        });
    }
}




// WEBPACK FOOTER //
// ./scripts/modules/simpleMap.js